import { batch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import {
  resetDesignProductAction,
  resetForcedProductPreviewsAction,
  resetMoreArtPrintsAction,
  resetOPPlusContentAction,
  resetPersonalisedProductAction,
  resetProductRecommendationsAction,
  setProductPreviewIndexAction,
} from '../slice';

const resetProductPageDataOperation = () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
  batch(() => {
    dispatch(resetForcedProductPreviewsAction());
    dispatch(resetProductRecommendationsAction());
    dispatch(setProductPreviewIndexAction(0));
    dispatch(resetDesignProductAction());
    dispatch(resetPersonalisedProductAction());
    dispatch(resetOPPlusContentAction());
    dispatch(resetMoreArtPrintsAction());
  });
};

export default resetProductPageDataOperation;
